var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-filter',{attrs:{"comparison":_vm.comparison},on:{"updateComparison":_vm.onGetComparison}}),_c('LocationSummaryCard',{attrs:{"comparison":_vm.comparison,"location":_vm.location}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }